
/*--------------------------------
//追従バナーボタン
--------------------------------*/
var thisOffset;
var endOffset;
window.addEventListener('load', function () {
  const topHero = document.querySelector('.top-hero');
  if (topHero) {
    thisOffset = topHero.offsetTop + topHero.offsetHeight;
    thisOffset = thisOffset / 2;
  }

  const topTarget = document.querySelector('.p-top-target');
  if (topTarget) {
    endOffset = topTarget.offsetTop;
  }
});

window.addEventListener("scroll", () => {
  const endOffsetElement = document.querySelector('.top-partner');
  const bannerAnimation = document.querySelector('.banner-animation');
  
  if (endOffsetElement && bannerAnimation) {
    const endOffset = endOffsetElement.offsetTop;
    if(window.scrollY >= 1 && window.scrollY < endOffset) {
      bannerAnimation.classList.add("bannner-active");
    } else {
      bannerAnimation.classList.remove("bannner-active");
    }
  }
})

// バナーを閉じるボタン
const bannerCloseButton = document.querySelector(".top-banner-button-close a");
if (bannerCloseButton) {
  bannerCloseButton.addEventListener('click', function(e) {
    e.preventDefault();
    const topBanner = document.querySelector('.top-banner');
    if (topBanner) {
      topBanner.style.transition = 'opacity 0.5s ease-out';
      topBanner.style.opacity = '0';
      setTimeout(() => {
        topBanner.style.display = 'none';
      }, 500);
    }
  });
}